// Le travail de fond (téléchargement des données sur l'appareil) ne passe jamais
// avant l'écran: il démarre quand la page est inactive, s'efface devant toute
// requête d'un écran et rend la main au navigateur entre deux petits lots.

let premierPlan = 0; // requêtes d'écran en cours
let dernierMouvement = 0; // instant de la dernière requête d'écran terminée

export const debutPremierPlan = () => {
  premierPlan += 1;
};

export const finPremierPlan = () => {
  premierPlan = Math.max(0, premierPlan - 1);
  dernierMouvement = Date.now();
};

export const requetesDEcranEnCours = () => premierPlan;

const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/** Rend la main au navigateur: un temps mort du fil principal, sinon la macrotâche suivante. */
export const ceder = () =>
  new Promise((resolve) => {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(() => resolve(), { timeout: 200 });
    } else {
      setTimeout(resolve, 0);
    }
  });

/**
 * Attend que plus aucune requête d'écran ne soit en cours (et qu'aucune ne vienne
 * de finir). Borné: un écran qui interroge sans cesse ne bloque pas le fond pour toujours.
 */
export async function attendreEcranLibre({ calme = 150, maximum = 8000 } = {}) {
  const limite = Date.now() + maximum;
  while (Date.now() < limite) {
    if (premierPlan === 0 && Date.now() - dernierMouvement >= calme) return;
    // eslint-disable-next-line no-await-in-loop
    await pause(60);
  }
}

/** Lance `travail` quand la page est inactive, après un court répit pour l'affichage du premier écran. */
export function quandInactif(travail, { repit = 1200, delaiMax = 5000 } = {}) {
  let annule = false;
  let minuterie = null;
  let inactif = null;
  const lancer = () => {
    if (!annule) travail();
  };
  minuterie = setTimeout(() => {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
      inactif = window.requestIdleCallback(lancer, { timeout: delaiMax });
    } else {
      lancer();
    }
  }, repit);
  return () => {
    annule = true;
    clearTimeout(minuterie);
    if (inactif !== null && typeof window !== 'undefined' && window.cancelIdleCallback) window.cancelIdleCallback(inactif);
  };
}

// --- Données locales prêtes ---------------------------------------------------
// Tant que le téléchargement initial n'est pas fait, il n'y a rien à lire en
// local: les lectures vont droit au serveur (comme avant), sans détour par la
// base de l'appareil. Le premier écran après la toute première connexion ne
// paie donc rien pour le hors ligne.
let donneesLocalesPretes = false;
export const definirDonneesLocalesPretes = (pret) => {
  donneesLocalesPretes = Boolean(pret);
};
export const donneesLocalesSontPretes = () => donneesLocalesPretes;
